import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

import './assets/styles/index.css'

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

Vue.filter('verbose_insurance', function (value) {
  const verboses = {
    phone_breakage : 'Téléphone : Casse & Oxydation',
    trottinette: 'Trottinette : RC et IA',
    nomade: 'Assurance appareils nomades',
    phone_breakage_steal: 'Téléphone : Casse, oxydation et vol'
  }

  return verboses[value] ?? null;
})